const relations = {
	description:
		"Hier kunt u relaties aanmaken en producten/diensten aan deze relaties koppelen. Een relatie kan een klant van u zijn of een afdeling. Hierdoor krijgt u een overzicht met welke producten bij welke relatie horen. Ook kunnen de gegevens van een relatie gebruikt worden bij bijvoorbeeld domeinnamen en SSL certificaten.",
	dialog_add: {
		description: "Een nieuwe relatie aanmaken",
		input_description: {
			label: "Omschrijving relatie",
			placeholder: "Geef de relatie optioneel een omschrijving",
		},
		input_name: {
			label: "Naam relatie",
			placeholder: "Geef de relatie een naam",
		},
		messages: {
			success: "Relatie <strong>{{relation_name}}</strong> is succesvol toegevoegd!",
		},
		radio_is_business: {
			label: "Type relatie",
			values: {
				business: "Zakelijk",
				private: "Particulier",
			},
		},
		title: "Nieuwe relatie toevoegen",
	},
	item: {
		add: {
			description:
				"Selecteer een relatie om te koppelen aan product <strong>{{service_name}}</strong/>",
			input_label: "Selecteer een relatie",
			title: "Product relatie toevoegen",
		},
		delete: {
			description:
				"Weet je zeker dat je de koppeling met relatie <strong>{{relation}}</strong> wilt verwijderen voor product <strong>{{service_name}}</strong>?",
			not_found: "We hebben de relatie niet kunnen vinden. Probeer het later nog eens.",
			title: "Product ontkoppelen van relatie",
		},
	},
	overview_table: {
		empty: "Leeg",
		head: {
			description: "Beschrijving",
			id: "ID",
			name: "Naam",
			type: "Type relatie",
		},
		relation_types: {
			business: "Zakelijk",
			private: "Particulier",
		},
	},
	service_type_list: {
		dadup: {
			no_dadup_connected: "Deze relatie heeft geen gekoppelde Dadup accounts",
			title: "daDup Storage",
		},
		domains: {
			no_domains_connected: "Deze relatie heeft geen gekoppelde domeinen.",
			title: "Domeinnamen",
		},
		pbs: {
			is_free_version: "Gratis versie",
			no_pbs_connected: "Deze relatie heeft geen Tuxis PBS datastores.",
			title: "Tuxis PBS",
		},
		qemu: {
			connect: "VPS succesvol gekoppeld van relatie",
			dialog_add: {
				description: "Selecteer hier een of meerdere VPS'en om te koppelen aan de relatie.",
				relation_overwrite_warning:
					"Let op! Deze wordt ontkoppeld van relatie <strong>{{linked_relation_name}}</strong>.",
				title: "VPS'en koppelen aan relatie",
			},
			dialog_add_select_multiple: {
				description: "Selecteer hier een of meerdere VPS'en om te koppelen aan de relatie.",
				empty: "Er zijn geen VPS'en beschikbaar om toe te koppelen aan de relatie.",
				linked_relation: "Momenteel gekoppeld aan deze relatie",
				title: "Selecteer beschikbare VPS'en",
			},
			disconnect: "VPS succesvol ontkoppeld van relatie",
			no_qemus_added: "Deze relatie heeft geen gekoppelde VPS'en.",
			title: "VPS'en",
		},
	},
	single: {
		delete: {
			button: "Relatie verwijderen",
			description:
				"Weet u zeker dat u relatie <strong>{{relation}}</strong> wilt verwijderen? De gekoppelde diensten worden ontkoppeld.",
			status_message: {
				success: "Relatie succesvol verwijderd",
			},
			title: "Relatie verwijderen",
		},
		domain_details: {
			address_details: {
				country: "Land",
				title: "Adresgegevens",
			},
			company_details: {
				title: "Bedrijfsgegevens",
			},
			contact_details: {
				title: "Persoonsgegevens",
			},
			description: "In deze sectie kunt u de domeingegevens van de relatie wijzigen.",
			status_message: {
				success: "Domeingegevens van relatie succesvol aangepast",
			},
			title: "Domeingegevens",
			trademark_details: {
				title: "Trademark informatie (optioneel)",
			},
			warning_message: {
				cannot_edit:
					"Let op! De velden 'Voornaam' 'Tussenvoegsel' 'Achternaam' zijn niet meer aanpasbaar na het opslaan. Zorg er voor dat de juiste gegevens hier staan, indien u het toch wilt aanpassen dient u een nieuwe relatie aan te maken.",
				cannot_edit_register_company:
					"Let op! Het veld 'Bedrijfsnaam' is niet meer aanpasbaar na het opslaan. Zorg er voor dat de juiste gegevens hier staan.",
				cannot_edit_register_personal:
					"Let op! De velden 'Voornaam' 'Tussenvoegsel' 'Achternaam' zijn niet meer aanpasbaar na het opslaan. Zorg er voor dat de juiste gegevens hier staan.",
				cannot_edit2:
					"Let op! Het veld 'Bedrijfsnaam' is niet meer aanpasbaar na het opslaan. Zorg er voor dat de juiste gegevens hier staan, indien u het toch wilt aanpassen dient u een nieuwe relatie aan te maken.",
				message:
					"Let op! Bij het opslaan van dit formulier word de ingevulde informatie toegepast aan alle domeinen die gelinkt zijn aan deze relatie.",
			},
		},
		navbar: {
			information: "Informatie",
			overview: "Producten & diensten",
		},
		relation_details: {
			description: "In deze sectie kunt u de naam en beschrijving van de relatie wijzigen.",
			status_message: {
				success: "Relatiedetails succesvol aangepast",
			},
			title: "Relatiegegevens",
		},
		title: "Relatie",
	},
	title: "Relaties",
};

export default relations;
